/* globals APP_NAME */

import { APP_NAME } from "gatsby-env-variables"
import { useEffect, useState } from "react"

const getImageSize = async (imageUrl) => {
  if (!imageUrl) return null
  try {
    const img = new Image()
    img.src = imageUrl
    await new Promise((resolve, reject) => {
      img.onload = resolve
      img.onerror = reject
    })
    return { width: img.naturalWidth, height: img.naturalHeight }
  } catch (error) {
    console.error("Erro ao obter tamanho da imagem:", error)
    return null
  }
}

const Img = ({
  className,
  src,
  srcSet,
  alt,
  width,
  height,
  loading = "lazy",
  draggable = "false",
  optimize = true,
}) => {
  const optimizedImg = optimize ? "/m/" : ""
  const mkt =
    APP_NAME === "ccbr"
      ? "cartoes"
      : APP_NAME === "mastercard" || APP_NAME === "cp"
      ? "iq"
      : APP_NAME
  const isStoryblokImg = /a.storyblok.com/.test(src)
  const isSvg = src?.includes(".svg") || src?.includes("data:image");
  const replaceImg = isStoryblokImg
    ? src?.replace("a.storyblok.com", `assets.${mkt}.com.br`) + (isSvg ? "" : optimizedImg)
    : isSvg
    ? src
    : src + optimizedImg;

  const [size, setSize] = useState({ width: null, height: null })

  useEffect(() => {
    const imageToCheck = srcSet || src
    if (imageToCheck) {
      getImageSize(imageToCheck).then((imageSize) => {
        if (imageSize) setSize(imageSize)
      })
    }
  }, [src, srcSet])

  if (srcSet) {
    return (
      <picture>
        <source media="(min-width: 767px)" srcSet={srcSet} />
        <img
          className={className}
          src={src}
          alt={alt}
          width={width || size.width || "auto"}
          height={height || size.height || "auto"}
          loading={loading}
          draggable={draggable}
        />
      </picture>
    )
  }

  return (
    <img
      className={className}
      src={src}
      alt={alt}
      width={width || size.width || "auto"}
      height={height || size.height || "auto"}
      loading={loading}
      draggable={draggable}
    />
  )
}

export default Img
